const getApiBaseUrl = () => process.env.API_BASE_URL;
const LOCAL_BASE_API = 'api/v1';

const Endpoints = {
    // research
    suggestedResearch: (params = '') => `${getApiBaseUrl()}/suggested-research${params}`,

    // instruments
    instrumentDetails: (instrumentId) => `${getApiBaseUrl()}/instruments/${instrumentId}`,
    getInstruments: (params = '') => `${getApiBaseUrl()}/instruments${params}`,

    // market performance
    homeMarketPerformance: () => `${getApiBaseUrl()}/market-groups/nzx/performance`,

    // secure accounts
    accounts: () => `${getApiBaseUrl()}/accounts`,
    accountSummary: (accountNumber) => `${getApiBaseUrl()}/accounts/${accountNumber}`,
    accountAssets: (accountNumber, params = '') => `${getApiBaseUrl()}/accounts/${accountNumber}/assets${params}`,
    accountAssetsPDF: (accountNumber, params = '') => `${getApiBaseUrl()}/accounts/${accountNumber}/assets/report${params}`,
    accountPerformanceValues: (accountNumber, params = "") => `${getApiBaseUrl()}/accounts/${accountNumber}/performance-values${params}`,
    getNCAccountStatus: (params = '') => `${getApiBaseUrl()}/non-custodial-status${params}`,
    getNCAccounts: (params = '') => `${getApiBaseUrl()}/non-custodial-accounts${params}`,
    getNCAccountSummary: (accountNumber) => `${getApiBaseUrl()}/non-custodial-accounts/${accountNumber}`,
    getNCAccountAssets: (accountNumber) => `${getApiBaseUrl()}/non-custodial-accounts/${accountNumber}/assets`,

    // watchlist
    watchlist: () => `${getApiBaseUrl()}/watchlist`,

    // enquiries
    saveEnquiry: () => `${getApiBaseUrl()}/enquiries`,

    // these routes are not calling API_BASE_URL as that calls the test API
    // which proxies to the test site these routes modify database
    // per environment therefore called as bellow.

    // multi-factor authentication
    checkPassword: `${LOCAL_BASE_API}/user/confirm-password`,
    setupEmailMFA: `${LOCAL_BASE_API}/mfa/email/setup`,
    verifyEmailMFA: `${LOCAL_BASE_API}/mfa/email/verify`,
    setupSmsMFA: () => `${LOCAL_BASE_API}/mfa/sms/setup`,
    verifySmsMFA: () => `${LOCAL_BASE_API}/mfa/sms/verify`,
    setupAuthenticatorMFA: (params = '') => `${LOCAL_BASE_API}/mfa/authenticator/setup${params}`,
    verifyAuthenticatorMFA: `${LOCAL_BASE_API}/mfa/authenticator/verify`,
    removeUserMFA: (params = '') => `${LOCAL_BASE_API}/mfa${params}`,

    // users
    user: () => `${LOCAL_BASE_API}/user`,
};

export default Endpoints;
